var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57808e-07 0.766493C1.55334e-07 0.973934 0.07338 1.15488 0.218732 1.30641L6.14994 6.99851L0.218732 12.6906C0.0733799 12.8436 1.16492e-08 13.0231 9.17547e-09 13.2306C6.70176e-09 13.438 0.0733799 13.6175 0.218732 13.7705C0.365495 13.9235 0.544715 14 0.752159 14C0.959603 14 1.15011 13.925 1.31663 13.7705L7.77986 7.52227C7.92662 7.39133 8 7.21772 8 6.99998C8 6.78224 7.92662 6.6072 7.77986 6.47626L1.31663 0.228044C1.15011 0.0765095 0.961014 -1.24769e-07 0.752159 -1.23151e-07C0.543304 -1.21534e-07 0.365495 0.0765095 0.218732 0.228044C0.07338 0.381049 1.60264e-07 0.560525 1.5779e-07 0.767965L1.57808e-07 0.766493Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClose);
export default __webpack_public_path__ + "static/media/arrow-close.8f75aebcd7976f7dc4fd8b1d8465892f.svg";
export { ForwardRef as ReactComponent };